import { PORTAL_BASE_PATH } from 'shipperguide/core/ui/PortalRoute'

export const PORTAL_LINK_BASE_PATH = '/portal-link'

export const PORTAL_LINK_BIDS_PATH = `${PORTAL_LINK_BASE_PATH}/bids`

export const PORTAL_LINK_RFP_PATH = `${PORTAL_LINK_BASE_PATH}/rfp`

export const PORTAL_LINK_TENDER_PATH = `${PORTAL_LINK_BASE_PATH}/tender`

export const PORTAL_LINK_SHIPMENTS_PATH = `${PORTAL_LINK_BASE_PATH}/shipments`

export const PORTAL_LINK_SHIPMENT_PATH = `${PORTAL_LINK_BASE_PATH}/shipment`

export function isPortalLinkPath(pathname: string): boolean {
  return pathname === PORTAL_LINK_BASE_PATH || pathname.startsWith(`${PORTAL_LINK_BASE_PATH}/`)
}

// A portal-link ?token= is a magic-link token, and /portal would save it as the invite token.
export function getPortalLocationWithoutToken({
  pathname,
  search,
}: {
  pathname: string
  search: string
}) {
  const query = new URLSearchParams(search)
  query.delete('token')

  return {
    pathname: pathname.replace(PORTAL_LINK_BASE_PATH, PORTAL_BASE_PATH),
    search: query.toString(),
  }
}
